<div class="flex flex-col bg-white comic-book">
  <!-- Section One -->

  <div
    class="rotate flex flex-wrap min-h-screen background-green relative border-4 border-black"
  >
    <span class="absolute w-1/4 right-0 top-0 h-full halftone top-right"></span>
    <span
      class="absolute w-1/4 left-0 top-0 h-full halftone bottom-left"
    ></span>
    <div class="straighten w-full md:w-1/2 p-4 flex items-center">
      <div class="p-4">
        <h2 class="text-container">
          <span
            class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-purple-950 via-purple-700 to-purple-900"
            >Building in Public</span
          >
        </h2>
        <h3
          class="text-4xl md:text-6xl font-semibold tracking-tight select-none mb-2 text-gray-900"
        >
          October 2024
        </h3>
        <p class="mt-6 text-2xl text-green-100">
          We're excited to announce that Study Heroes is now building in public!
          This means we're sharing our development process, challenges, and
          victories in real-time with our community. By embracing transparency,
          we aim to gather valuable feedback faster, allowing us to iterate and
          improve our platform more efficiently. This approach not only
          accelerates our development cycle but also ensures that we're creating
          features that truly resonate with our users. We invite educators,
          students, and education enthusiasts to join us on this journey,
          providing insights and suggestions that will shape the future of Study
          Heroes. Together, we can create an educational platform that meets the
          real needs of our users and pushes the boundaries of what's possible
          in online learning.
        </p>
        <div class="mt-10">
          <p class="text-2xl text-pink-50 mb-6">
            Stay updated with our latest resources and initiatives by following
            us:
          </p>
          <div class="flex space-x-6">
            <a
              href="https://x.com/studyheroesapp"
              target="_blank"
              class="text-pink-50 hover:text-pink-200"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 1668.56 1221.19"
                fill="currentColor"
              >
                <path
                  d="m283.94 167.31 386.39 516.64-388.83 420.05h87.51l340.42-367.76 275.05 367.76h297.8l-408.13-545.7 361.92-390.99h-87.51l-313.51 338.7-253.31-338.7zm128.69 64.46h136.81l604.13 807.76h-136.81z"
                  transform="translate(52.390088 -25.058597)"
                />
              </svg>
            </a>
            <a
              href="https://www.youtube.com/@StudyHeroes"
              target="_blank"
              class="text-pink-50 hover:text-pink-200"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="48"
                height="48"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path
                  d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="w-full md:w-1/2 p-4 flex items-center justify-center">
      <div class="p-4 straighten">
        <div class="mt-10">
          <a
            href="/get-involved"
            class="mr-4 btn btn-lg border-2 bg-purple-700 px-3.5 py-2.5 text-xl font-semibold text-white shadow-sm shadow-slate-950 hover:bg-purple-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-purple-600"
          >
            Give us a Hand
          </a>
        </div>
      </div>
    </div>
  </div>

  <!-- Section Two -->
  <!-- <div class="rotate flex flex-wrap md:flex-nowrap gap-8">
    <div class="w-full md:w-1/3 h-auto border-4 border-black shadow-md">
      <div class="background-yellow">
        <img src="https://placehold.co/600" alt="" />
      </div>
    </div>
    <div
      class="w-full md:w-2/3 border-4 border-black background-yellow flex items-center"
    >
      <div class="absolute bottom-0 right-0 z-20">
        <div
          class="text-container p-4 bg-gradient-to-l from-red-800 via-red-800 to-bg-red-800/30 text-right"
        >
          <span
            class="font-bangers text-4xl md:text-6xl pr-2 text-white"
            data-text="Study Heroes puts Education, Teachers and Students first."
            >to be continued...</span
          >
        </div>
      </div>

      <div class="p-8">
        <h2 class="text-container">
          <span
            class="text text-flat font-bangers text-6xl md:text-8xl pr-2 bg-gradient-to-r from-blue-950 via-blue-700 to-blue-900"
            >Education first</span
          >
        </h2>
        <h3
          class="text-4xl md:text-6xl font-semibold tracking-tight select-none mb-2 text-gray-900"
        >
          Join today and take control of your education!
        </h3>
        <p class="mt-6 text-2xl md:3xl text-yellow-100">
          Study Heroes puts education, educators and students first. Instant
          access to quality education, no sign in, no pay wall.
        </p>
        <div class="flex items-center justify-start gap-x-6 mt-12">
          <a
            href="#"
            class="text-xl animate-bounce rounded-md bg-blue-950 px-3.5 py-2.5 font-semibold text-white shadow-sm shadow-slate-950 hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
            >Sign Up It's Free</a
          >
          <a href="#" class="text-xl font-semibold leading-6 text-gray-900"
            >Learn more <span aria-hidden="true">→</span></a
          >
        </div>
      </div>
    </div>
  </div> -->
</div>
